import { render, staticRenderFns } from "./natResourceAddLicense.vue?vue&type=template&id=04b6f106&scoped=true&"
import script from "./natResourceAddLicense.vue?vue&type=script&lang=js&"
export * from "./natResourceAddLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6f106",
  null
  
)

export default component.exports